/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `PendingSubscriptionUpgrade` - PENDING_SUBSCRIPTION_UPGRADE
 * * `Invited` - INVITED
 * * `PendingEmailVerification` - PENDING_EMAIL_VERIFICATION
 * * `Active` - ACTIVE
 * * `Deactivated` - DEACTIVATED
 * * `AgentDisabled` - AGENT_DISABLED
 * * `AgentConfigError` - AGENT_CONFIG_ERROR
 */
export enum UserStatus {
  PENDING_SUBSCRIPTION_UPGRADE = 'PendingSubscriptionUpgrade',
  INVITED = 'Invited',
  PENDING_EMAIL_VERIFICATION = 'PendingEmailVerification',
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  AGENT_DISABLED = 'AgentDisabled',
  AGENT_CONFIG_ERROR = 'AgentConfigError',
}
